<template>
  <div v-if="image || isEditing" class="container paragraph--margin">
    <DrupalLink
      v-if="link?.uri?.path && image"
      :to="link.uri.path"
      is-link
      class="md:max-w-[50%] block"
    >
      <FieldItemTypeImage
        v-bind="image.image"
        config="dynamic/noop"
        img-class="[&_picture]:w-auto [&_img]:w-auto"
      />
    </DrupalLink>
    <FieldItemTypeImage
      v-else-if="image"
      v-bind="image.image"
      config="dynamic/noop"
      img-class="md:max-w-[50%] [&_picture]:w-auto [&_img]:w-auto [&_img]:max-w-auto"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLogoPictogrammFragment } from '#graphql-operations'

const { isEditing } = defineBlokkli({
  bundle: 'logo_pictogramm',
  globalOptions: ['bkVisibleLanguages'],
  chunkName: 'rare',
})

defineProps<{
  link?: ParagraphLogoPictogrammFragment['link']
  image?: ParagraphLogoPictogrammFragment['image']
}>()

defineOptions({
  name: 'ParagraphLogoPictogram',
})
</script>
